// extracted by mini-css-extract-plugin
module.exports = {"root":"NavigationWrapper__root--1UGC2","navbar":"NavigationWrapper__navbar--1rAqM","changeNav":"NavigationWrapper__changeNav--1ivqY","bounce":"NavigationWrapper__bounce--iDYfk"};